module.exports = __webpack_public_path__ + "frontend/images/faq/screen-payment-view-xs-e819b6d6f99eb031d4781a4dc93bc588.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/frontend/images/faq/screen-payment-view-xs.jpg
// module id = 342
// module chunks = 2